'use-client'
import CommonNav from '@/shared/components/commonNav'
import React, { useState, useMemo } from 'react'

function CommentaryFilter({ filterCommentary, match }: any) {
  // Initialize with the first tab as active
  const [activeTab, setActiveTab] = useState('all')
  
  // Dynamically generate tabs based on available innings
  const tabs = useMemo(() => {
    // Base tabs that are always present
    const baseTabs = [
      { navItem: 'All', value: 'all' },
      { navItem: 'Highlights', value: 'highlights' },
    ]
    
    // Get available innings from match data
    const availableInnings = match?.aInning?.map((i: any) => i?.nInningNumber) || []
    
    // Generate innings tabs based on available innings
    const inningsTabs = availableInnings.map((inning: number) => ({
      navItem: `${inning}${getInningsSuffix(inning)} Inn`,
      value: `${inning}`
    }))
    
    // Additional filter tabs
    const filterTabs = [
      { navItem: 'W', value: 'w' },
      { navItem: '6s', value: '6' },
      { navItem: '4s', value: '4' }
    ]
    
    // Combine all tabs
    return [...baseTabs, ...inningsTabs, ...filterTabs]
  }, [match])

  // Helper function to get correct suffix for innings
  function getInningsSuffix(inning: number): string {
    if (inning === 1) return 'st'
    if (inning === 2) return 'nd'
    if (inning === 3) return 'rd'
    return 'th'
  }

  // Handle tab change
  function handleTabChange(tab: any) {
    setActiveTab(tab.value)
    
    // Map tab values to the appropriate filter values
    let highlightValue = null
    let inningValue = 0

    switch (tab.value) {
      case 'all':
        // Reset all filters
        highlightValue = null
        inningValue = 0
        break
      case 'highlights':
        // All highlights (4s, 6s, wickets)
        highlightValue = ['4', '6', 'w']
        break
      case 'overs':
        // Handle overs filter logic
        // This would depend on your specific implementation
        break
      case 'w':
        // Wickets only
        highlightValue = ['w']
        break
      case '6':
        // 6s only
        highlightValue = ['6']
        break
      case '4':
        // 4s only
        highlightValue = ['4']
        break
      default:
        // Check if it's an innings tab (1, 2, 3, 4)
        if (!isNaN(parseInt(tab.value))) {
          inningValue = parseInt(tab.value)
        }
        break
    }

    // Call the filter function with the appropriate values
    filterCommentary(highlightValue, inningValue)
  }

  return (
    <>
      <div>
        <CommonNav
          items={tabs}
          variant={'pills'}
          asButton
          tabClassName='!font-normal !text-base !text-nowrap'
          className='flex pt-3 mb-8 overflow-x-auto'
          isActive={(item) => item?.value === activeTab}
          onTabChange={(tab) => handleTabChange(tab)}
        />
      </div>
    </>
  )
}

export default CommentaryFilter
